import { createElement } from 'react';
import { icons } from './icons.js';

/** A Lucide line icon. Decorative by default: the text next to it carries the meaning. */
export default function Icon({ name, size = 20, className = '', strokeWidth = 2 }) {
  const shapes = icons[name];
  if (!shapes) return null;
  return <svg className={`mk-icon ${className}`} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    {shapes.map(([tag, attributes], index) => createElement(tag, { key: index, ...attributes }))}
  </svg>;
}
